import React from 'react';
import { Sun, Moon, LayoutGrid, List } from 'lucide-react';

const ViewControls = ({ isDarkMode, setIsDarkMode, viewMode, setViewMode }) => {
  return (
    <div className="flex items-center space-x-2">
      <div className={`hidden md:flex rounded-lg p-1 space-x-1 ${isDarkMode ? 'bg-gray-800' : 'bg-gray-200'}`}>
        <button
          onClick={() => setViewMode('grid')}
          className={`p-2 rounded transition-colors ${
            viewMode === 'grid'
              ? 'bg-blue-600 text-white'
              : isDarkMode 
                ? 'text-gray-400 hover:text-gray-200' 
                : 'text-gray-600 hover:text-gray-800'
          }`}
          title="Grid weergave"
        >
          <LayoutGrid size={20} />
        </button>
        <button
          onClick={() => setViewMode('list')}
          className={`p-2 rounded transition-colors ${
            viewMode === 'list'
              ? 'bg-blue-600 text-white'
              : isDarkMode 
                ? 'text-gray-400 hover:text-gray-200' 
                : 'text-gray-600 hover:text-gray-800'
          }`}
          title="Lijst weergave"
        >
          <List size={20} />
        </button>
      </div>

      <button
        onClick={() => setIsDarkMode(!isDarkMode)}
        className={`p-2 rounded-lg transition-colors ${
          isDarkMode 
            ? 'bg-gray-800 text-gray-400 hover:text-gray-200' 
            : 'bg-gray-200 text-gray-600 hover:text-gray-800'
        }`}
        title={isDarkMode ? 'Light mode' : 'Dark mode'}
      >
        {isDarkMode ? <Sun size={20} /> : <Moon size={20} />}
      </button>
    </div>
  );
};

export default ViewControls;